import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IRecordViewProcess, IRenderProcess } from '../../model/model';

@Component({
	selector: 'common-process',
	templateUrl: './process.component.html',
	styleUrls: ['./process.component.scss']
})
export class ProcessComponent implements OnInit {
	@Input() buttonShowNum = 3;
	@Input() processes: IRecordViewProcess[];
	@Input() processStatus: { [key: string]: IRenderProcess };
	@Output() processClick = new EventEmitter<IRecordViewProcess>();
	constructor() {}

	ngOnInit() {}
}
